import { CommonModule } from '@angular/common';
import { Component, ViewChild } from '@angular/core';
import { FormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';

import { I18NextPipe } from 'angular-i18next';
import { AlertComponent, ButtonComponent, MbsPopupType, MbsSize, ModalComponent, ModalFooterDirective, RadioComponent } from 'mbs-ui-kit';
import Computer from 'mbs-ui-shared@models/Computer';
import { ConnectionType } from 'mbs-ui-shared@models/ConnectionType';

@Component({
  selector: 'mbs-remote-connection-choose-type-modal-component',
  templateUrl: './remote-connection-choose-type-modal.component.html',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    ButtonComponent,
    NgbTooltipModule,
    AlertComponent,
    I18NextPipe,
    ModalComponent,
    RadioComponent,
    ModalFooterDirective
  ]
})
export class RemoteConnectionChooseTypeModalComponent {
  @ViewChild(ModalComponent, { static: true }) baseModal: ModalComponent;
  public connectionType = ConnectionType;
  public readonly size = MbsSize;
  public mbsPopupType = MbsPopupType;
  public form = new FormControl(ConnectionType.SSH);
  public computer: Computer;

  ngAfterViewInit(): void {
    if (this.baseModal.data) {
      this.computer = this.baseModal.data.computer;
    }
  }
}
